(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PolicySettings', PolicySettings);

	PolicySettings.$inject = [ '$resource' ];

	function PolicySettings($resource) {
		var resourceUrl = 'api/policySettings/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : false
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {

						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();
